// 5-part advisor nurture series for the admin "Email Advisors" page.
// {business} is replaced with the selected advisor's business name at insert.
export const ADVISOR_EMAIL_SERIES = [
  {
    id: 'advisor-1-welcome',
    name: '1 — Welcome: your first 15 minutes',
    subject: 'Welcome to RV Match AI — your first 15 minutes',
    body: `Hi {business},

Welcome aboard. Here's the 15-minute setup that pays for itself the first week:

1. Upload your inventory sheet (PDF or spreadsheet) — the AI extracts every unit, price, and days-on-lot automatically.
2. Share your branded matching page link — every buyer who fills the application becomes a scored lead in your pipeline.
3. Open Inventory Watch — it reads your sheet daily and tells you what's aging, what got a price cut, and what to push.

One advisor told us the first lead that came through the form already knew the exact floorplan they wanted. That's the point: buyers arrive matched, not browsing.

Reply to this email any time — a real person answers.

— The RV Match AI Team`,
  },
  {
    id: 'advisor-2-pipeline',
    name: '2 — The lead that never went cold',
    subject: 'The lead that never went cold',
    body: `Hi {business},

Quick story. A buyer fills out an RV Match application on a Tuesday night — family of five, half-ton truck, $30k budget. By the time they hit submit, the platform has already matched them against live inventory, scored the fit, and dropped them in the pipeline with the reasons spelled out.

Wednesday morning the advisor opens the lead, sees "3 fits, best: 2024 bunkhouse under tow limit," and sends one email with the matches link. The buyer clicks straight into their own dashboard — no login friction, no PDF attachments.

That lead never went cold because it never sat in an inbox as a name and a phone number. It arrived as a decision waiting to happen.

Your pipeline works the same way today. Log in and check the intent scores on your newest leads.

— The RV Match AI Team`,
  },
  {
    id: 'advisor-3-inventory',
    name: '3 — Your inventory just started talking',
    subject: 'Your inventory just started talking',
    body: `Hi {business},

Every unit on your lot has a story it's trying to tell you: how long it's been sitting, what the discount off list really is, which buyers it matches. Most systems make you dig for it. Inventory Watch just tells you.

Upload your sheet and it flags:
- Units past 90 days (with a Monday-morning aging email so nothing hides)
- Price cuts your buyers should hear about today
- Which active leads match which units — automatically

You can even attach a screenshot of any sheet or listing to the chat and ask questions about it in plain English.

Ten minutes with Inventory Watch on a Monday sets up the whole week's talk track.

— The RV Match AI Team`,
  },
  {
    id: 'advisor-4-toolkit',
    name: '4 — Win the internet lead',
    subject: 'How advisors win the internet lead',
    body: `Hi {business},

The internet lead goes to whoever answers best, not just fastest. RV Match AI stacks the deck:

- 35 ready-made, story-driven email templates with one-click merge tags for every tool and product
- A matches link that signs buyers straight into their own dashboard
- Trade appraisals buyers complete themselves — photos included — that turn into pipeline leads with one click
- Appointment invites, confirmations and reminders that sound like a human wrote them

The advisors doing best send the match review invitation within an hour of a new lead. It's two clicks from the lead card.

— The RV Match AI Team`,
  },
  {
    id: 'advisor-5-founding',
    name: '5 — Founding advisor rate',
    subject: 'Your founding advisor rate is still open',
    body: `Hi {business},

A heads-up, not a hard sell: the founding advisor rate you're on (or eligible for) is the lowest RV Match AI will ever be. As the platform grows, new advisors come in at the standard rate — founders keep theirs for life.

What founders get today:
- Full pipeline, inventory intelligence, buyer matching, trades and email center
- Every new feature the day it ships
- A direct line to us — advisor feedback drives the roadmap

If you've been meaning to finish setup or move to the full plan, this is the week to do it. Reply and we'll handle it personally.

— The RV Match AI Team`,
  },
];
